export type Difficulty = 'easy' | 'medium' | 'hard';
export type Topic = 'algebra' | 'geometry' | 'advanced' | 'problem' | 'random';

export interface Question {
  id: number;
  difficulty: Difficulty;
  topic: Topic;
  question: string;
  choices: string[];
  answer: number; // index of correct answer
  explanation?: string;
}

export const questions: Question[] = [
    {
      id: 1,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'The function f is defined by f(x) = 25x + 30. What is the value of f(x) when x = 2?',
      choices: ['50', '57', '80', '110'],
      answer: 2,
    },
    {
      id: 2,
      difficulty: 'medium',
      topic: 'algebra',
      question: 'A cargo helicopter delivers only 100-pound packages and 120-pound packages. For each delivery trip, the helicopter must carry at least 10 packages, and the total weight of the packages can be at most 1,100 pounds. What is the maximum number of 120-pound packages that the helicopter can carry per trip?',
      choices: ['2', '4', '5', '6'],
      answer: 2,
    },
    {
      id: 3,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'The function f is defined by f(x) = 8x. For what value of x does f(x) = 72?',
      choices: ['8', '9', '64', '80'],
      answer: 1,
    },
    {
      id: 4,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'For the linear function f, f(x) = 4x + b, where b is a constant and f(7) = 28. What is the value of b?',
      choices: ['0', '1', '4', '7'],
      answer: 0,
    },
    {
      id: 5,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'Gabriella deposits $35 in a savings account at the end of each week. At the beginning of the 1st week of a year there was $600 in that savings account. How much money, in dollars, will be in the account at the end of the 4th week of that year?',
      choices: ['460', '635', '639', '740'],
      answer: 3,
    },
    {
      id: 6,
      difficulty: 'medium',
      topic: 'algebra',
      question: 'A cargo helicopter delivers only 100-pound packages and 120-pound packages. For each delivery trip, the helicopter must carry at least 10 packages, and the total weight of the packages can be at most 1,100 pounds. What is the maximum number of 120-pound packages that the helicopter can carry per trip?',
      choices: ['2', '4', '5', '6'],
      answer: 2,
    },
    {
      id: 7,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'The function f is defined by f(x) = 8x. For what value of x does f(x) = 72?',
      choices: ['8', '9', '64', '80'],
      answer: 1,
    },
    {
      id: 8,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'For the linear function f, f(x) = 4x + b, where b is a constant and f(7) = 28. What is the value of b?',
      choices: ['0', '1', '4', '7'],
      answer: 0,
    },
    {
      id: 9,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'Gabriella deposits $35 in a savings account at the end of each week. At the beginning of the 1st week of a year there was $600 in that savings account. How much money, in dollars, will be in the account at the end of the 4th week of that year?',
      choices: ['460', '635', '639', '740'],
      answer: 3,
    },
    {
      id: 10,
      difficulty: 'hard',
      topic: 'algebra',
      question: '3x = 36y - 45. One of the two equations in a system of linear equations is given. The system has no solution. Which equation could be the second equation in this system?',
      choices: ['x = 4y', '1/4x = 4y', 'x = 12y - 15', '1/3x = 12y - 15'],
      answer: 1,
    },
    {
      id: 11,
      difficulty: 'medium',
      topic: 'algebra',
      question: 'The system of equations x + 1/2y = 4 and x - 1/2y = 2 has solution (x,y). What is the value of x?',
      choices: ['3', '7/2', '4', '6'],
      answer: 3,
    },
    {
      id: 12,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'A veterinarian recommends that each day a certain rabbit should eat 25 calories per pound of the rabbit\'s weight, plus an additional 11 calories. Which equation represents this situation, where c is the total number of calories the veterinarian recommends the rabbit should eat each day if the rabbit\'s weight is x pounds?',
      choices: ['c = 25x', 'c = 36x', 'c = 11x + 25', 'c = 25x + 11'],
      answer: 3,
    },
    {
      id: 13,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'The total cost f(x), in dollars, to lease a car for 36 months from a particular car dealership is given by f(x) = 36x + 1,000, where x is the monthly payment, in dollars. What is the total cost to lease a car when the monthly payment is $400?',
      choices: ['$13,400', '$13,000', '$15,400', '$37,400'],
      answer: 2,
    },
    {
      id: 14,
      difficulty: 'hard',
      topic: 'algebra',
      question: 'The graph of the equation ax + ky = 6 is a line in the xy-plane, where a and k are constants. If the line contains the points (-2,-6) and (0,-3), what is the value of k?',
      choices: ['-2', '-1', '2', '3'],
      answer: 0,
    },
    {
      id: 15,
      difficulty: 'hard',
      topic: 'algebra',
      question: 'A window repair specialist charges $220 for the first two hours of repair plus an hourly fee for each additional hour. The total cost for 5 hours of repair is $400. Which function f gives the total cost, in dollars, for x hours of repair, where x >= 2?',
      choices: ['f(x) = 60x + 100', 'f(x) = 60x + 220', 'f(x) = 80x', 'f(x) = 80x + 220'],
      answer: 0,
    },
    {
      id: 16,
      difficulty: 'hard',
      topic: 'algebra',
      question: 'Hector used a tool called an auger to remove corn from a storage bin at a constant rate. The bin contained 24,000 bushels of corn when Hector began to use the auger. After 5 hours of using the auger, 19,350 bushels of corn remained in the bin. If the auger continues to remove corn at this rate, what is the total number of hours Hector will have been using the auger when 12,840 bushels of corn remain in the bin?',
      choices: ['3', '7', '8', '12'],
      answer: 3,
    },
    {
      id: 17,
      difficulty: 'medium',
      topic: 'algebra',
      question: 'The function h is defined by h(x) = 4x + 28. The graph of y = h(x) in the xy-plane has an x-intercept at (a, 0) and a y-intercept at (0, b), where a and b are constants. What is the value of a + b?',
      choices: ['21', '28', '32', '35'],
      answer: 0,
    },
    {
      id: 18,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'If 4x - 28 = -24, what is the value of x - 7?',
      choices: ['-24', '-22', '-6', '-1'],
      answer: 2,
    },
    {
      id: 19,
      difficulty: 'hard',
      topic: 'algebra',
      question: 'For line h, a table shows three values of x and their corresponding values of y. Line k is the result of translating line h down 5 units in the xy-plane. What is the x-intercept of line k? The points for line h are (18, 130), (23, 160), (26, 178).',
      choices: ['-29/6', '-9/2', '-1/6', '-17/6'],
      answer: 3,
    },
    {
      id: 20,
      difficulty: 'hard',
      topic: 'algebra',
      question: 'An economist modeled the demand Q for a certain product as a linear function of the selling price P. The demand was 20,000 units when the selling price was $40 per unit, and the demand was 15,000 units when the selling price was $60 per unit. Based on the model, what is the demand, in units, when the selling price is $55 per unit?',
      choices: ['16,250', '16,500', '16,750', '17,500'],
      answer: 0,
    },
    {
      id: 21,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'Hiro and Sofia purchased shirts and pants from a store. The price of each shirt purchased was the same and the price of each pair of pants purchased was the same. Hiro purchased 4 shirts and 2 pairs of pants for $86, and Sofia purchased 3 shirts and 5 pairs of pants for $166. Which of the following systems of linear equations represents the situation, if x represents the price, in dollars, of each shirt and y represents the price, in dollars, of each pair of pants?',
      choices: [
        '4x + 2y = 86 and 3x + 5y = 166',
        '4x + 3y = 86 and 2x + 5y = 166',
        '4x + 2y = 166 and 3x + 5y = 86',
        '4x + 3y = 166 and 2x + 5y = 86'
      ],
      answer: 0,
    },
    {
      id: 22,
      difficulty: 'easy',
      topic: 'algebra',
      question: 'The equation d = 16 - x/30 gives the estimated amount of diesel d, in gallons, that remains in the gas tank of a truck after being driven x miles, where 0 <= x <= 480. What is the estimated amount of diesel, in gallons, that remains in the gas tank of the truck when x = 300?',
      choices: ['0', '6', '14', '16'],
      answer: 1,
    },
    {
      id: 23,
      difficulty: 'hard',
      topic: 'algebra',
      question: 'In the given system of equations, ax + by = 72 and 6x + 2by = 56, a and b are constants. The graphs of these equations in the xy-plane intersect at the point (4, y). What is the value of a?',
      choices: ['3', '4', '6', '14'],
      answer: 3,
    },
    {
      id: 24,
      difficulty: 'easy',
      topic: 'algebra',
      question: "A store sells two different-sized containers of a certain Greek yogurt. The store's sales of this Greek yogurt totaled 1,277.94 dollars last month. The equation 5.48x + 7.30y = 1,277.94 represents this situation, where x is the number of smaller containers sold and y is the number of larger containers sold. According to the equation, which of the following represents the price, in dollars, of each smaller container?",
      choices: ['5.48', '7.30y', '7.30', '5.48x'],
      answer: 0,
    },
    {
      id: 25,
      difficulty: 'easy',
      topic: 'algebra',
      question: '7(2x - 3) = 63. Which equation has the same solution as the given equation?',
      choices: ['2x - 3 = 9', '2x - 3 = 56', '2x - 21 = 63', '2x - 21 = 70'],
      answer: 0,
    },
    {
        id: 26,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'Line k is defined by y = 3x + 15. Line j is perpendicular to line k in the xy-plane. What is the slope of line j?',
        choices: ['-1/3', '-1/12', '-1/18', '-1/45'],
        answer: 0,
      },
      {
        id: 27,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'The point (8, 2) in the xy-plane is a solution to which of the following systems of inequalities?',
        choices: ['x > 0 and y > 0', 'x > 0 and y < 0', 'x < 0 and y > 0', 'x < 0 and y < 0'],
        answer: 0,
      },
      {
        id: 28,
        difficulty: 'easy',
        topic: 'algebra',
        question: '5x = 15 and -4x + y = -2. The solution to the given system of equations is (x,y). What is the value of x + y?',
        choices: ['-17', '-13', '13', '17'],
        answer: 2,
      },
      {
        id: 29,
        difficulty: 'hard',
        topic: 'algebra',
        question: 'The cost of renting a backhoe for up to 10 days is $270 for the first day and $135 for each additional day. Which of the following equations gives the cost y, in dollars, of renting the backhoe for x days, where x is a positive integer and x <= 10?',
        choices: ['y = 270x - 135', 'y = 270x + 135', 'y = 135x + 270', 'y = 135x + 135'],
        answer: 3,
      },
      {
        id: 30,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'What value of p satisfies the equation 5p + 180 = 250?',
        choices: ['14', '65', '86', '250'],
        answer: 0,
      },
      {
        id: 31,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'The front of a roller-coaster car is at the bottom of a hill and is 15 feet above the ground. If the front of the roller-coaster car rises at a constant rate of 8 feet per second, which of the following equations gives the height h, in feet, of the front of the roller-coaster car s seconds after it starts up the hill?',
        choices: ['h = 8s + 15', 'h = 15s + 335/8', 'h = 8s + 335/15', 'h = 15s + 8'],
        answer: 0,
      },
      {
        id: 32,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'If 3x - 27 = 24, what is the value of x - 9?',
        choices: ['1', '8', '24', '35'],
        answer: 1,
      },
      {
        id: 33,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'Line p is defined by 2y + 18x = 9. Line r is perpendicular to line p in the xy-plane. What is the slope of line r?',
        choices: ['-9', '-1/9', '1/9', '9'],
        answer: 2,
      },
      {
        id: 34,
        difficulty: 'hard',
        topic: 'algebra',
        question: 'Adam\'s school is a 20-minute walk or a 5-minute bus ride away from his house. The bus runs once every 30 minutes, and the number of minutes, w, that Adam waits for the bus varies between 0 and 30. Which of the following inequalities gives the values of w for which it would be faster for Adam to walk to school?',
        choices: ['w - 5 < 20', 'w - 5 > 20', 'w + 5 < 20', 'w + 5 > 20'],
        answer: 3,
      },
      {
        id: 35,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'If f is the function defined by f(x) = (2x-1)/3, what is the value of f(5)?',
        choices: ['4/3', '7/3', '3', '9'],
        answer: 2,
      },
      {
        id: 36,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'w + 7 = 357. What value of w is the solution to the given equation?',
        choices: ['51', '350', '364', '3,577'],
        answer: 1,
      },
      {
        id: 37,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'The given equation d = 16t represents the distance d, in inches, where t represents the number of seconds since an object started moving. Which of the following is the best interpretation of 16 in this context?',
        choices: ['The object moved a total of 16 inches.', 'The object moved a total of 16t inches.', 'The object is moving at a rate of 16 inches per second.', 'The object is moving at a rate of 1/16 inches per second.'],
        answer: 2,
      },
      {
        id: 38,
        difficulty: 'hard',
        topic: 'algebra',
        question: 'Given the system of equations 7x + 6y = 5 and 28x + 24y = 20. For each real number r, which of the following points lies on the graph of each equation in the xy-plane for the given system?',
        choices: ['(r, -7r/6 + 5/6)', '(r, 7r/6 + 5/6)', '(7r/4 + 5, -49r/24 + 20)', '(-6r/7 + 5/7, r)'],
        answer: 3,
      },
      {
        id: 39,
        difficulty: 'easy',
        topic: 'algebra',
        question: '(p + 3) + 8 = 10. What value of p is the solution to the given equation?',
        choices: ['-1', '5', '15', '21'],
        answer: 0,
      },
      {
        id: 40,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'f(x) = 39. For the given linear function f, which table gives three values of x and their corresponding values of f(x)?',
        choices: [
          'f(0)=0, f(1)=0, f(2)=0',
          'f(0)=39, f(1)=39, f(2)=39',
          'f(0)=0, f(1)=39, f(2)=78',
          'f(0)=39, f(1)=0, f(2)=-39'
        ],
        answer: 1,
      },
      {
        id: 41,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'A mixture consisting of only vitamin D and calcium has a total mass of 150 grams. The mass of vitamin D in the mixture is 50 grams. What is the mass, in grams, of calcium in the mixture?',
        choices: ['200', '150', '100', '50'],
        answer: 2,
      },
      {
        id: 42,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'A company that provides whale-watching tours takes groups of 21 people at a time. The company\'s revenue is 80 dollars per adult and 60 dollars per child. If the company\'s revenue for one group consisting of adults and children was 1,440 dollars, how many people in the group were children?',
        choices: ['3', '9', '12', '18'],
        answer: 2,
      },
      {
        id: 43,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'Line k is defined by y = (17/7)x + 4. Line j is parallel to line k in the xy-plane. What is the slope of line j?',
        choices: ['17/4', '17/7', '4', '17'],
        answer: 1,
      },
      {
        id: 44,
        difficulty: 'hard',
        topic: 'algebra',
        question: '-12x + 14y = 36 and -6x + 7y = -18. How many solutions does the given system of equations have?',
        choices: ['Exactly one', 'Exactly two', 'Infinitely many', 'Zero'],
        answer: 3,
      },
      {
        id: 45,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'In the xy-plane, the graph of the linear function f contains the points (0, 3) and (7,31). Which equation defines f, where y = f(x)?',
        choices: ['f(x) = 28x + 34', 'f(x) = 3x + 38', 'f(x) = 4x + 3', 'f(x) = 7x + 3'],
        answer: 2,
      },
      {
        id: 46,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'y = 12x - 20 and y = 28. What is the solution (x, y) to the given system of equations?',
        choices: ['(4, 28)', '(20, 28)', '(28, 4)', '(28, 20)'],
        answer: 0,
      },
      {
        id: 47,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'The number y is 84 less than the number x. Which equation represents the relationship between x and y?',
        choices: ['y = x + 84', 'y = 1/84x', 'y = 84x', 'y = x - 84'],
        answer: 3,
      },
      {
        id: 48,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'The function f is defined by f(x) = 4x - 3. What is the value of f(10)?',
        choices: ['-30', '37', '40', '43'],
        answer: 1,
      },
      {
        id: 49,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'At how many points do the graphs of the equations y = x + 20 and y = 8x intersect in the xy-plane?',
        choices: ['0', '1', '2', '8'],
        answer: 1,
      },
      {
        id: 50,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'Marisa needs to hire at least 10 staff members for an upcoming project. The staff members will be made up of junior directors, who will be paid $640 per week, and senior directors, who will be paid $880 per week. Her budget for paying the staff members is no more than $9,700 per week. She must hire at least 3 junior directors and at least 1 senior director. Which of the following systems of inequalities represents the conditions described if x is the number of junior directors and y is the number of senior directors?',
        choices: [
          '640x + 880y >= 9,700, x + y <= 10, x >= 3, y >= 1',
          '640x + 880y <= 9,700, x + y >= 10, x >= 3, y >= 1',
          '640x + 880y >= 9,700, x + y >= 10, x <= 3, y <= 1',
          '640x + 880y <= 9,700, x + y <= 10, x <= 3, y <= 1'
        ],
        answer: 1,
      },
      {
        id: 51,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'For a snowstorm in a certain town, the minimum rate of snowfall recorded was 0.6 inches per hour, and the maximum rate of snowfall recorded was 1.8 inches per hour. Which inequality is true for all values of s, where s represents a rate of snowfall, in inches per hour, recorded for this snowstorm?',
        choices: ['s >= 2.4', 's >= 1.8', '0 <= s <= 0.6', '0.6 <= s <= 1.8'],
        answer: 3,
      },
      {
        id: 52,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'During a portion of a flight, a small airplane\'s cruising speed varied between 150 miles per hour and 170 miles per hour. Which inequality best represents this situation, where s is the cruising speed, in miles per hour, during this portion of the flight?',
        choices: ['s <= 20', 's <= 150', 's <= 170', '150 <= s <= 170'],
        answer: 3,
      },
      {
        id: 53,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'John paid a total of $165 for a microscope by making a down payment of $37 plus p monthly payments of $16 each. Which of the following equations represents this situation?',
        choices: ['16p - 37 = 165', '37p - 16 = 165', '16p + 37 = 165', '37p + 16 = 165'],
        answer: 2,
      },
      {
        id: 54,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'y = 3x and 2x + y = 12. The solution to the given system of equations is (x, y). What is the value of 5x?',
        choices: ['24', '15', '12', '5'],
        answer: 2,
      },
      {
        id: 55,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'Valentina bought two containers of beads. In the first container 30% of the beads are red, and in the second container 70% of the beads are red. Together, the containers have at least 400 red beads. Which inequality shows this relationship, where x is the total number of beads in the first container and y is the total number of beads in the second container?',
        choices: ['0.3x + 0.7y >= 400', '0.7x + 0.3y <= 400', 'x/3 + y/7 <= 400', '30x + 70y >= 400'],
        answer: 0,
      },
      {
        id: 56,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'y = x + 4. Which table gives three values of x and their corresponding values of y for the given equation?',
        choices: [
          'x=[0,1,2], y=[4,5,6]',
          'x=[0,1,2], y=[6,5,4]',
          'x=[0,1,2], y=[2,1,0]',
          'x=[0,1,2], y=[0,1,2]'
        ],
        answer: 0,
      },
      {
        id: 57,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'As part of a science project on evaporation, Amaya measured the height of a liquid in a container over a period of time. The function f(x) = 33 - 0.18x gives the estimated height, in centimeters (cm), of the liquid in the container x days after the start of the project. Which of the following is the best interpretation of 33 in this context?',
        choices: [
          'The estimated height, in cm, of the liquid at the start of the project',
          'The estimated height, in cm, of the liquid at the end of the project',
          'The estimated change in the height, in cm, of the liquid each day',
          'The estimated number of days for all of the liquid to evaporate'
        ],
        answer: 0,
      },
      {
        id: 58,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'Lorenzo purchased a box of cereal and some strawberries at the grocery store. Lorenzo paid $2 for the box of cereal and $1.90 per pound for the strawberries. If Lorenzo paid a total of $9.60 for the box of cereal and the strawberries, which of the following equations can be used to find p, the number of pounds of strawberries Lorenzo purchased? (Assume there is no sales tax.)',
        choices: ['1.90p + 2 = 9.60', '1.90p - 2 = 9.60', '1.90 + 2p = 9.60', '1.90 - 2p = 9.60'],
        answer: 0,
      },
      {
        id: 59,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'The total cost, in dollars, to rent a surfboard consists of a $25 service fee and a $10 per hour rental fee. A person rents a surfboard for t hours and intends to spend a maximum of $75 to rent the surfboard. Which inequality represents this situation?',
        choices: ['10t <= 75', '10 + 25t <= 75', '25t <= 75', '25 + 10t <= 75'],
        answer: 3,
      },
      {
        id: 60,
        difficulty: 'easy',
        topic: 'algebra',
        question: '3a + 4b = 25. A shipping company charged a customer $25 to ship some small boxes and some large boxes. The equation above represents the relationship between a, the number of small boxes, and b, the number of large boxes, the customer had shipped. If the customer had 3 small boxes shipped, how many large boxes were shipped?',
        choices: ['3', '4', '5', '6'],
        answer: 1,
      },
      {
        id: 61,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'What is the equation of the line that passes through the point (0, 5) and is parallel to the graph of y = 7x + 4 in the xy-plane?',
        choices: ['y = 5x', 'y = 7x + 5', 'y = 7x', 'y = 5x + 7'],
        answer: 1,
      },
      {
        id: 62,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'A group of 202 people went on an overnight camping trip, taking 60 tents with them. Some of the tents held 2 people each, and the rest held 4 people each. Assuming all the tents were filled to capacity and every person got to sleep in a tent, exactly how many of the tents were 2-person tents?',
        choices: ['30', '20', '19', '18'],
        answer: 2,
      },
      {
        id: 63,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'A petting zoo sells two types of tickets. The standard ticket, for admission only, costs $5. The premium ticket, which includes admission and food to give to the animals, costs $12. One Saturday, the petting zoo sold a total of 250 tickets and collected a total of $2,300 from ticket sales. Which of the following systems of equations can be used to find the number of standard tickets, s, and premium tickets, p, sold on that Saturday?',
        choices: [
          's + p = 250 and 5s + 12p = 2,300',
          's + p = 250 and 12s + 5p = 2,300',
          '5s + 12p = 250 and s + p = 2,300',
          '12s + 5p = 250 and s + p = 2,300'
        ],
        answer: 0,
      },
      {
        id: 64,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'In North America, the standard width of a parking space is at least 7.5 feet and no more than 9.0 feet. A restaurant owner recently resurfaced the restaurant\'s parking lot and wants to determine the number of parking spaces, n, in the parking lot that could be placed perpendicular to a curb that is 135 feet long, based on the standard width of a parking space. Which of the following describes all the possible values of n?',
        choices: ['18 <= n <= 135', '7.5 <= n <= 9', '15 <= n <= 135', '15 <= n <= 18'],
        answer: 3,
      },
      {
        id: 65,
        difficulty: 'medium',
        topic: 'algebra',
        question: 'Two customers purchased the same kind of bread and eggs at a store. The first customer paid 12.45 dollars for 1 loaf of bread and 2 dozen eggs. The second customer paid 19.42 dollars for 4 loaves of bread and 1 dozen eggs. What is the cost, in dollars, of 1 dozen eggs?',
        choices: ['3.77', '3.88', '4.15', '4.34'],
        answer: 3,
      },
      {
        id: 66,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'x + y = 75. The equation above relates the number of minutes, x, Maria spends running each day and the number of minutes, y, she spends biking each day. In the equation, what does the number 75 represent?',
        choices: [
          'The number of minutes spent running each day',
          'The number of minutes spent biking each day',
          'The total number of minutes spent running and biking each day',
          'The number of minutes spent biking for each minute spent running'
        ],
        answer: 2,
      },
      {
        id: 67,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'g(x) = 11x + 4. For the given linear function g, which table shows three values of x and their corresponding values of g(x)?',
        choices: [
          'g(-1)=7, g(0)=11, g(1)=15',
          'g(-1)=-4, g(0)=0, g(1)=4',
          'g(-1)=-7, g(0)=4, g(1)=15',
          'g(-1)=-11, g(0)=0, g(1)=11'
        ],
        answer: 2,
      },
      {
        id: 68,
        difficulty: 'medium',
        topic: 'algebra',
        question: '3(2x-6) - 11 = 4(x-3) + 6. If x is the solution to the equation above, what is the value of x - 3?',
        choices: ['23/2', '17/2', '15/2', '-15/2'],
        answer: 1,
      },
      {
        id: 69,
        difficulty: 'easy',
        topic: 'algebra',
        question: 'y = 4 and x = y + 6. The solution to the given system of equations is (x,y). What is the value of x?',
        choices: ['10', '6', '4', '2'],
        answer: 0,
      }
    ];